"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TimelineItem = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _timelineDot = _interopRequireDefault(require("./timeline-dot"));

require("./timeline-item.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var TimelineItem = function TimelineItem(_ref) {
  var className = _ref.className,
      lineBeforeClassName = _ref.lineBeforeClassName,
      lineAfterClassName = _ref.lineAfterClassName,
      dot = _ref.dot,
      left = _ref.left,
      right = _ref.right;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('timeline-item', className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('timeline-item__progress-line', lineBeforeClassName)
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "timeline-item__left"
  }, left), /*#__PURE__*/_react["default"].createElement("div", {
    className: "timeline-item__center"
  }, dot), /*#__PURE__*/_react["default"].createElement("div", {
    className: "timeline-item__right"
  }, right), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('timeline-item__progress-line', lineAfterClassName)
  }));
};

exports.TimelineItem = TimelineItem;
TimelineItem.propTypes = {
  className: _propTypes["default"].string,
  lineBeforeClassName: _propTypes["default"].string,
  lineAfterClassName: _propTypes["default"].string,
  left: _propTypes["default"].node,
  dot: _propTypes["default"].node,
  right: _propTypes["default"].node
};
TimelineItem.defaultProps = {
  className: null,
  lineBeforeClassName: null,
  lineAfterClassName: null,
  left: null,
  right: null,
  dot: /*#__PURE__*/_react["default"].createElement(_timelineDot["default"], null)
};
var _default = TimelineItem;
exports["default"] = _default;